import { useContext } from "react"
import { Select } from "web/components/Form/Controls"
import { EditFieldList } from "web/components"
import { TLOContext } from "web/contexts"
import { useViewable } from "web/hooks/data"
import { useModals } from "web/hooks/modals"

import SummarySettings from "../../../components/SummarySettings/SummarySettings"

function SettingsModal({ viewType, viewId, enableFieldSelection }) {
  const viewable = useViewable({ type: viewType, id: viewId })

  async function handleNewTemplateSelection(value) {
    await viewable.applyTemplate(value.value)
  }
  const matchedTemplates = viewable.matched_templates
  const hasTemplates = matchedTemplates.length > 0

  const [selectedTemplate] = matchedTemplates.filter(
    (template) => template.selected
  )

  return (
    <div className="h-full">
      <div className="m-0 h-full overflow-y-auto px-7 py-5">
        <div className="grid gap-y-5">
          {hasTemplates && (
            <div>
              <h3 className="font-medium leading-6 text-neutral-4">Template</h3>
              <div className="mt-3">
                <Select
                  id="templates"
                  testId="templates"
                  value={selectedTemplate}
                  onChange={handleNewTemplateSelection}
                  options={matchedTemplates}
                  placeholder={"Custom"}
                  sortSuggestions={false}
                />
              </div>
            </div>
          )}
          {enableFieldSelection && (
            <div>
              <h3 className="font-medium leading-6 text-neutral-4">Fields</h3>
              <div className="mt-3">
                <EditFieldList
                  fields={viewable.fields}
                  allFields={viewable.available_fields}
                />
              </div>
            </div>
          )}
          <div>
            <h3 className="font-medium leading-6 text-neutral-4">
              Summarization
            </h3>
            <div className="mt-3">
              <SummarySettings
                showDetails={viewable.table.show_details}
                showGrandTotals={viewable.table.show_grand_totals}
                showGroupTotals={viewable.table.show_group_totals}
                useAverages={viewable.table.use_averages}
                updateTable={viewable.updateTable}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default function useSettingsModal({
  viewType,
  viewId,
  enableFieldSelection = true,
}) {
  const { showModal } = useModals()
  const tloContext = useContext(TLOContext) || {}

  return async function () {
    return await showModal({
      title: "Table Settings",
      fullScreen: false,
      heightPixels: 800,
      widthPixels: 800,
      component: () => (
        <TLOContext.Provider value={tloContext}>
          <SettingsModal
            viewType={viewType}
            viewId={viewId}
            enableFieldSelection={enableFieldSelection}
          />
        </TLOContext.Provider>
      ),
    })
  }
}
